import React from "react";
import AutorenewOutlined from "@mui/icons-material/AutorenewOutlined";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { startScreenNavigation } from "@telemetry/navigationTiming";
import { paths } from "@utils/navigation";
import { useNavigate } from "react-router-dom";

const RENEWABLE_STATUSES = new Set(["APPROVED", "EXPIRED"]);

interface RenewPortOperatorLicenseProps {
  licenseId: string;
  companyId?: string | null;
  status?: string;
  isPortOperatorLicense?: boolean;
  isVendorMasterContext?: boolean;
}

const RenewPortOperatorLicense: React.FC<RenewPortOperatorLicenseProps> = ({
  licenseId,
  companyId,
  status,
  isPortOperatorLicense = false,
  isVendorMasterContext = false,
}) => {
  const navigate = useNavigate();
  const userCompanyId = useAuthStore((state) => state.user?.companyId ?? null);
  const isSameCompany = Boolean(companyId && userCompanyId && companyId === userCompanyId);

  if (!isVendorMasterContext || !isPortOperatorLicense || !isSameCompany) return null;

  return (
    <FlowActionButton
      langBase="licensing"
      isActionAvailable={Boolean(status && RENEWABLE_STATUSES.has(status))}
      labelKey="renew-port-operator-license"
      testId="renew-port-operator-license"
      variant="outlined"
      startIcon={<AutorenewOutlined />}
      onClick={() => {
        startScreenNavigation(
          "Licenses",
          window.location.pathname,
          "Port Operator License Renewal",
        );
        navigate(
          `/${paths.licenses.index}/${paths.licenses.portOperatorLicenseRenewal.replace(":renewalId", licenseId)}`,
        );
      }}
    />
  );
};

export default RenewPortOperatorLicense;
